import { actions } from '../constants';
import { remoteCall } from '../lib';
import cookie from 'react-cookie';
import { hashHistory } from 'react-router';

function signupRequest() {
  return {
    type: actions.SIGNUP_REQUESTED,
    payload: { }
  };
}

function signupCompleted(account, sessionToken) {
  return {
    type: actions.SIGNUP_COMPLETED,
    payload: {
      account,
      sessionToken
    }
  };
}

function signupFailed(error) {
  return {
    type: actions.SIGNUP_FAILED,
    payload: {
      error
    }
  };
}

export function signup(emailAddress, password, accessCode) {
  return (dispatch) => {
    dispatch(signupRequest());
    remoteCall(`providers`, null, 'post', {
      provider: {
        emailAddress,
        password
      },
      accessCode
    }).then((response) =>{
      onAuth(response);
      dispatch(signupCompleted(response.get('provider'), response.get('sessionToken') ));
    }).catch((err) => {
      dispatch(signupFailed(err));
    });
  };
}

function loginRequest() {
  return {
    type: actions.LOGIN_REQUESTED,
    payload: { }
  };
}

function loginCompleted(account, sessionToken) {
  return {
    type: actions.LOGIN_COMPLETED,
    payload: {
      account,
      sessionToken
    }
  };
}

function loginFailed(error) {
  return {
    type: actions.LOGIN_FAILED,
    payload: {
      error
    }
  };
}

export function login(emailAddress, password) {
  return (dispatch) => {
    dispatch(loginRequest());
    remoteCall(`providerSessions`, null, 'post', {
      account: {
        emailAddress,
        password
      }
    }).then((response) =>{
      onAuth(response);
      dispatch(loginCompleted(response.get('provider'), response.get('sessionToken')));
    }).catch((err) => {
      dispatch(loginFailed(err));
    });
  };
}

function onAuth(response) {
  const token = response.get('sessionToken');
  const fullProvider = response.get('provider');
  const user = {
    id: fullProvider.get('id'),
    emailAddress: fullProvider.get('emailAddress'),
    firstName: fullProvider.get('firstName'),
    lastName: fullProvider.get('lastName')
  };
  cookie.save('session', JSON.stringify({ token, user }), { path: '/', maxAge: 60*60*24/*, secure: true */});
}

export function onUpdateAccount(account) {
  return {
    type: actions.UPDATE_ACCOUNT,
    payload: {
      account
    }
  };
}

export function clearSession() {
  return (dispatch) => {
    cookie.remove('session');
    dispatch({
      type: actions.CLEAR_SESSION,
      payload: {}
    });
    hashHistory.replace({
      pathname: '/login',
      state: null
    });
  };
}

function logoutRequest() {
  return {
    type: actions.LOGOUT_REQUESTED,
    payload: { }
  };
}

function logoutFailed(error) {
  return {
    type: actions.LOGOUT_FAILED,
    payload: {
      error
    }
  };
}

export function logout() {
  return (dispatch) => {
    dispatch(logoutRequest());
    remoteCall(`providerSessions`, null, 'delete').then((response) =>{
      dispatch(clearSession());
    }).catch((err) => {
      dispatch(clearSession());
      dispatch(logoutFailed(err));
    });
  };
}




// WEBPACK FOOTER //
// ./src/actions/auth.js